import React from 'react';
import ListWidget from '../../components/ListWidget/ListWidget';
import { useSelector } from 'react-redux';

const Dashboard: React.FC<any> = () => {
  const { shiftToDoItems } = useSelector((state: any) => state.shiftToDo);

  return (
    <div>
      <ListWidget
        width={30}
        height={50}
        headline={'Notes for Oncoming Shift'}
        itemsToRender={shiftToDoItems}
      />
    </div>
  );
};

export default Dashboard;
